<template>
  <div class="booking-summary">
    <div class="booking-summary__main">
      <div class="summary">
        <div class="summary__block">
          <h2>{{ $t('booking_request.booking') }}</h2>
          <div>
            {{ $t('booking_request.from') }} {{ booking.from | formatDate }} {{ $t('booking_request.to') }} {{ booking.to | formatDate }}
          </div>
        </div>
        <div class="summary__block" v-if="owner.name">
          <h2>{{ $t('booking_request.owner') }}</h2>
          <div>{{ owner.name }}</div>
          <div>{{ owner.email }}</div>
        </div>
        <div v-if="boat.name">
        <h2>{{ $t('booking_request.boat') }}</h2>
        <div>{{ boat.name }}</div>
        <div>{{ boat.cin }}</div>
        </div>
      </div>
      <div class="quote">
        <div v-loading="loadingPrice" class="quote__box">
          <div>
            <h2 class="quote__box__title">{{ $t('booking_request.quote') }}</h2>
            <div class="quote__box__price">{{ quote }} *</div>
          </div>
        </div>
        <div class="quote__disclaimer">*{{ $t('booking_request.quote_disclaimer') }}</div>
      </div>
    </div>
    <form v-if="canBook" class="booking-summary__footer" @submit.prevent="submitForm()">
      <label>
        <input v-model="privacy" type="checkbox">
          {{ $t('booking_request.accept') }} <a :href="privacyLink" target="_blank" rel="noreferrer noopener">{{ $t('booking_request.privacy_label') }}</a>
      </label>
      <label>
        <input v-model="rules" type="checkbox">
        {{ $t('booking_request.accept') }} <a :href="rulesLink" target="_blank" rel="noreferrer noopener">{{ $t('booking_request.rules_label') }}</a>
      </label>
      {{ $t('booking_request.quote_message') }}
      <div class="booking-request__continue">
        <button type="submit">{{ $t('booking_request.send_request') }}</button>
        <div v-if="showError" class="error-message">{{ $t('booking_request.accept_privacy_and_port_regulations') }}</div>
      </div>
    </form>
  </div>
</template>

<script>
import { moment } from '@nodopiano/buzz-fields'

export default {
  filters: {
    formatDate: function(date) {
      return moment(date).format('DD MMMM YYYY')
    }
  },

  props: {
    owner: {
      type: Object,
      required: true
    },
    boat: {
      type: Object,
      required: true
    },
    booking: {
      type: Object,
      required: true
    },
    initialQuote: {
      type: [Object, Boolean],
      default: false
    }
  },

  data() {
    return {
      quote: '0.00€',
      privacy: false,
      rules: false,
      showError: false,
      loadingPrice: false
    }
  },

  computed: {
    canSubmit() {
      return this.privacy && this.rules
    },
    privacyLink() {
      return this.$store.getters.options.privacy || ''
    },
    rulesLink() {
      return this.$store.getters.options.rules || ''
    },
    canBook() {
      return this.$store.getters.options.canBook || false
    }
  },

  async created() {
    if (!this.initialQuote) {
      let params = this.$urlBuilder
        .set('from', this.booking.from)
        .set('to', this.booking.to)
        .set('width', this.boat.width)
        .set('length', this.boat.length)
        .set('resident', this.booking.resident ? 1 : 0)
        .get()

      this.loadingPrice = true
      const { data } = await this.$ajax({
        url: `/api/quotation${params}`
      })
      this.quote = data && data.data ? `${Number(data.data.total).toFixed(2)}€` : 'impossibile'
      this.loadingPrice = false
    } else {
      this.quote = this.initialQuote
    }
  },

  methods: {
    submitForm: function() {
      if (!this.canSubmit) return (this.showError = true)
      if (this.canSubmit) {
        this.$emit('submit')
        this.showError = false
      }
    }
  }
}
</script>

<style lang="scss">
.booking-summary {
  &__main {
    border-bottom: 5px double;
    align-items: flex-end;
    display: flex;
    justify-content: space-between;
    margin: 2rem 0;
  }
}

.booking-request {
  &__continue {
    flex-flow: row wrap;
    display: flex;
    justify-content: flex-end;
    align-items: center;

    .error-message {
      padding-top: 0.5rem;
      text-align: right;
      color: #a81b1b;
      font-size: 0.8rem;
      font-style: italic;
      width: 100%;
    }
  }
}

.quote {
  flex-shrink: 1;
  flex-basis: 40%;
  text-align: end;

  &__box {
    background: blue;
    color: white;
    border: 20px double blue;
    padding: 1rem 2rem;

    &__price {
      font-size: 2.5rem;
    }

    &__title {
      color: white;
    }
  }

  &__disclaimer {
    padding: .5rem .5rem .5rem 2rem;
  }
}

.summary {
  flex-shrink: 1;
  flex-basis: 60%;
}
</style>
